module.exports = __webpack_public_path__ + "img/esc_1_act_2.bb62afda.png";